module.exports = __webpack_public_path__ + "media/assets/good_at/webpack-20067be5983282920c1e6cae86c62952.png";